export default __webpack_public_path__ + "static/media/Plissee 22 vertikal ausmessen front.1c71aba5.jpg";